import { Button, Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import BackButton from "../BackButton";
import InputTextFieldGrid from "../common/InputTextFieldGrid";
import CustomButton from "components/CustomButton";
import InputSelectFieldGrid from "components/common/InputSelectFieldGrid";

const TaskForm = ({ title, goBack, defaultValues, submit }) => {
  const { control, handleSubmit } = useForm({ defaultValues });

  const handlerSubmit = (data) => {
    submit(data);
  }

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center" >
        <div>
          <BackButton name={title} click={goBack} />
        </div>
      </Grid>
      <Grid container justifyContent="center" alignItems="center" mt={"40px"}>
        <Grid width={"70%"} container spacing={3}>
          <InputSelectFieldGrid
            name="state"
            label="Estado"
            required="Debes seleccionar el estado"
            control={control}
            data={[
              { id: "Pendiente", name: "Pendiente" },
              { id: "En proceso", name: "En proceso" },
              { id: "Finalizada", name: "Finalizada" },
            ]}
          />
          <InputTextFieldGrid
            control={control}
            name="notes"
            multiline={true}
            label="Anotaciones"
            xs={12}
            rules={{
              validate: (value, formValues) => {
                if (formValues?.state === "Finalizada" && (value || "").trim().length < 10) {
                  return "Debes escribir una nota de minimo 10 caracteres para finalizar la tarea";
                }
                return true;
              },
            }}
          />
          <Grid container justifyContent="center" mt={5}>
            <CustomButton
              click={handleSubmit(handlerSubmit)}
              name={"Guardar"}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default TaskForm;
